import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../../reducers/userSlice";
import imagenVecino from "../../assets/img/blank.png";
import SatisfactionSurveyBanner from "../Otros/SatisfactionSurveyBanner";
export const ResumenVecino = ({key,cantidadPendientes,cantidadTotal,setverSoloPendientes}) => {

  const user = useSelector(selectUser);
  const [nombreCompleto, setnombreCompleto] = useState('');
  const [rut, setrut] = useState('');
  const [email, setemail] = useState('');

  useEffect(() => {
    if (user !== null) {
      setnombreCompleto(`${user.user.name} ${user.user.lastname} ${user.user.second_lastname}`);
      setrut(user.user.run);
      setemail(user.user.email);
    }
  }, [user]);

  useEffect(() => {
    //setverSoloPendientes(true);
  }, [])
  

  const handleModo=(tipo)=>{
    setverSoloPendientes(tipo);
  }

  return (
    <div className="">
      <div className="card w-100">
        <div className="card-body pt-2 pb-0 px-0">
          <div className="w-100 d-flex flex-stack flex-wrap">
            <div className="d-flex align-items-center f">
              <div className="symbol symbol-100px me-5">
                <img src={imagenVecino} alt="" />
              </div>
              <div className="d-flex flex-column fw-semibold fs-5 text-gray-600 text-dark">
                <div className="d-flex flex-column align-content-between flex-wrap">
                  <span className="fs-3">{nombreCompleto}</span>
                  <span className="text-muted fw-semibold fs-6">
                    {rut}
                  </span>
                  <span>{email}</span>
                  <NavLink to={`/EditarPerfil`}>
                    <span className="badge badge-light-primary py-2 px-3 mt-2"><i className="fas fa-pencil-alt mr-2"></i>Editar perfil</span>
                  </NavLink>         
                </div>
              </div>
            </div>

            {
              cantidadPendientes || cantidadTotal != null ? <ul className="nav nav-pills nav-pills-custom mt-3" role="tablist">

              <li className="nav-item mb-3 me-3 me-lg-6" role="presentation" onClick={()=>{handleModo(true)}}>
                  <a className="nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-info flex-column overflow-hidden w-100px h-140px
                      active" id="kt_stats_widget_16_tab_link_1" data-bs-toggle="pill" href="#" aria-selected="true" role="tab">
                      <div className="nav-icon">        
                        <i className="ki-duotone ki-information-5 fs-1">
                          <span className="path1"></span>
                          <span className="path2"></span>
                          <span className="path3"></span>
                        </i> 
                      </div>
                      <span className="nav-text text-gray-800 fw-bold fs-1">
                        {cantidadPendientes}
                      </span> 
                      <span className="nav-text text-gray-800 fw-bold fs-6 lh-1 mb-2">
                        Pendientes
                      </span> 
                      <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-info bg-opacity-25"></span>
                  </a>
              </li>

              <li className="nav-item mb-3 me-3 me-lg-6" role="presentation" onClick={()=>{handleModo(false)}}>
                  <a className="nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-100px h-140px
                      active" id="kt_stats_widget_16_tab_link_1" data-bs-toggle="pill" href="#" aria-selected="true" role="tab">
                      <div className="nav-icon">        
                        <i className="ki-duotone ki-tablet-ok fs-1">
                          <span className="path1"></span>
                          <span className="path2"></span>
                          <span className="path3"></span>
                        </i> 
                      </div>
                      <span className="nav-text text-gray-800 fw-bold fs-1">
                        {cantidadTotal}
                      </span> 
                      <span className="nav-text text-gray-800 fw-bold fs-6 lh-1 mb-2">
                        Total
                      </span> 
                      <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                  </a>
              </li>                      
          </ul> : <></>
            }
            

          </div>
        </div>
      </div>
    </div>
  );
};
